import { render, staticRenderFns } from "./SectionParentChecksCompact.vue?vue&type=template&id=12b9ef35&scoped=true&"
import script from "./SectionParentChecksCompact.vue?vue&type=script&lang=js&"
export * from "./SectionParentChecksCompact.vue?vue&type=script&lang=js&"
import style0 from "./SectionParentChecksCompact.vue?vue&type=style&index=0&id=12b9ef35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b9ef35",
  null
  
)

export default component.exports